import { Component } from '@angular/core';

@Component({
  selector: 'app-mi-total-test',
  standalone: true,
  imports: [],
  templateUrl: './mi-total-test.component.html',
  styleUrl: './mi-total-test.component.scss'
})
export class MiTotalTestComponent {

}
